import { render, staticRenderFns } from "./asGroup.vue?vue&type=template&id=77a2a822&scoped=true&"
import script from "./asGroup.vue?vue&type=script&lang=ts&"
export * from "./asGroup.vue?vue&type=script&lang=ts&"
import style0 from "./asGroup.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./asGroup.vue?vue&type=style&index=1&id=77a2a822&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a2a822",
  null
  
)

export default component.exports